import http from "@/http";

export class Dropdown {

    static getNextAlphabeticalItem(itemName: string, itemEls: HTMLCollection | NodeListOf<HTMLElement | ChildNode>, getItemName = (itemEl: HTMLElement) => itemEl.innerText) {
        itemName = itemName.toLowerCase();
        for (let i = 0; i < itemEls.length; i++) {
            let itemEl = <HTMLElement>itemEls[i];
            let nextItemName = getItemName(itemEl).toLowerCase();
            if (itemName < nextItemName) {
                return itemEl;
            }
        }
        return null;
    }
}

export class StimulusDropdown {
    private menu: HTMLElement;

    constructor(public readonly el: HTMLElement) { 
        this.menu = el.querySelector('.ww-dropdown__menu');
    }

    public getId() {
        return this.el.dataset.dropdownId;
    }

    public close() {
        this.el.dispatchEvent(new Event('close'));
    }

    public get text() {
        return this.el.querySelector<HTMLElement>('.ww-dropdown__text').innerText;
    }

    public set text(html: string) {
        this.el.querySelector('.ww-dropdown__text').innerHTML = html;
    }

    public contains(el: HTMLElement) {
        return this.el.contains(el) || this.menu.contains(el);
    }

    public isOpen() {
        let controller = this.el.dataset.controller;
        return controller && controller.indexOf('dropdown-menu') !== -1;
    }
}

export interface DropdownItem {
    id: string;
    name: string;
    icon?: string;
    selected?: boolean;
}

export interface DropdownItemQuery {
    /** Supplied automatically if using the dropdown service */
    dropdownId?: string;
    searchTerm?: string;
    itemIds?: string[];
}

export class DropdownService {

    constructor(private dropdown: { getId(): string }) { }

    getItemName(itemId: string): Promise<string> {
        let request = http.get({
            namespace: 'ww-dropdown',
            query: 'itemName',
            variables: JSON.stringify({
                dropdownId: this.dropdown.getId(),
                itemId: itemId,
            })
        });
        return request.then(http.decodeJson);
    }

    getItems(query: DropdownItemQuery): Promise<DropdownItem[]> {
        query.dropdownId = this.dropdown.getId();

        let request = http.get({
            namespace: 'ww-dropdown',
            query: 'items',
            variables: JSON.stringify(query)
        });

        let withToast = http.withToastOnError(request, 'Failed to load dropdown items');
        return withToast.then(http.decodeJson);
    }
}
